var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#20016B",
    fillRule: "evenodd",
    d: "M16.753 5.6H4.118a.4.4 0 0 1 0-.8h12.635l-2.118-2.117a.4.4 0 0 1 .566-.566l2.753 2.76a.4.4 0 0 1 .164.323v.002a.394.394 0 0 1-.117.28l-2.8 2.8a.4.4 0 0 1-.566-.565L16.753 5.6ZM3.749 14.953a.398.398 0 0 1 .086-.436l2.8-2.8a.4.4 0 1 1 .566.566L5.084 14.4h12.634a.4.4 0 0 1 0 .8H5.084L7.2 17.317a.4.4 0 1 1-.566.566l-2.8-2.8a.398.398 0 0 1-.086-.13Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRight);
export default __webpack_public_path__ + "static/media/arrow-left-right.32b58153128116c4adb6caba5508f1ab.svg";
export { ForwardRef as ReactComponent };